<div class="content">
    <div class="header">
        <ion-buttons>
            <ion-back-button defaultHref="" icon="close" text="" (click)="cancel()" class="red"></ion-back-button>
        </ion-buttons>
        <ion-buttons>
            <ion-back-button defaultHref="" icon="checkmark" text="" (click)="close()" class="green"></ion-back-button>
        </ion-buttons>
    </div>

    <haleo-picker-column [col]="column"
                         (onChange)="onChangeSelect($event)"></haleo-picker-column>
</div>

